import { render, staticRenderFns } from "./edittuwen.vue?vue&type=template&id=4dd1b874&scoped=true"
import script from "./edittuwen.vue?vue&type=script&lang=js"
export * from "./edittuwen.vue?vue&type=script&lang=js"
import style0 from "./edittuwen.vue?vue&type=style&index=0&id=4dd1b874&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dd1b874",
  null
  
)

export default component.exports